import { ReactNode } from 'react';
import styles from './EpStepContent.module.scss';

interface IEpStepContentCardProps {
  children: ReactNode;
  title: string;
  visible?: boolean;
}

export const EpStepContentCard = ({
  children,
  title,
  visible = true,
}: IEpStepContentCardProps) => {
  if (!visible) return null;

  return (
    <div className={styles['steps']}>
      <h5 className={styles['steps__title']}>{title}</h5>
      <div className={styles['steps__content']}>{children}</div>
    </div>
  );
};
